import React from 'react';
import PropTypes from 'prop-types';
import { Absolute } from 'rebass';
import styled from 'styled-components';
import Close from 'react-icons/lib/md/close';

const Container = styled(Absolute)`
  opacity: 0.4;
  cursor: pointer;
  transition: opacity cubic-bezier(.4, 0, .2, 1) 100ms;

  &:hover {
    opacity: 1;
  }
`;

const CloseButton = ({ onClick, ...otherProps }) => (
  <Container
    color="grey"
    f={4}
    onClick={onClick}
    {...otherProps}
  >
    <Close />
  </Container>
);

CloseButton.propTypes = {
  onClick: PropTypes.func,
};

CloseButton.defaultProps = {
  onClick: null,
};

export default CloseButton;



// WEBPACK FOOTER //
// ./src/app/components/close_button/index.js